import { render, staticRenderFns } from "./IconRouterLink.vue?vue&type=template&id=4935bb29&"
import script from "./IconRouterLink.vue?vue&type=script&lang=js&"
export * from "./IconRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports